// wishlist js
//=============================================================================//

var compareContainer = document.querySelector("#compare");
var isPageCompare = false;
if (compareContainer) {
  isPageCompare = compareContainer.getAttribute("data-page-compare");
  if (isPageCompare == "true") {
    isPageCompare = true;
  } else {
    isPageCompare = false;
  }
}

var LOCAL_STORAGE_COMPARE_KEY = "shopify-compare";
var LOCAL_STORAGE_DELIMITER = ",";
var BUTTON_ACTIVE_CLASS = "active";
var GRID_LOADED_CLASS = "loaded";

var selectorsCompare = {
  button: "[button-compare]",
  grid: "[grid-compare]",
};

document.addEventListener("DOMContentLoaded", function () {
  initButtons();
  initGrid();
});

var setupGrid = function (grid) {
  var compare = getCompare();
  var requests = compare.map(function (handle) {
    var productTileTemplateUrl = "/products/" + handle + "?view=card_compare";
    return fetch(productTileTemplateUrl).then(function (res) {
      if (res.status == 200) {
        return res.text();
      }
    });
  });
  Promise.all(requests).then(function (responses) {
    var compareProductCards = responses.join("");
    if (!compareProductCards) {
      var iconLoading = grid
        .closest(".compare")
        .querySelector(".icon-loading-compare");
      iconLoading.classList.add("hidden");
      grid.classList.add("compare-empty");
      compareProductCards = "No Product Data";
    }
    var iconLoading = grid
      .closest(".compare")
      .querySelector(".icon-loading-compare");
    iconLoading.classList.add("hidden");
    grid.innerHTML = compareProductCards;
    grid.classList.add(GRID_LOADED_CLASS);
    const grid_items = grid.querySelectorAll('.tp-prd-item');
    if(grid_items.length != 0){
      grid_items.forEach(function(item){
        item.classList.add('tp-grid__item');
      })
    }
    initButtons();

    var event = new CustomEvent("shopify-compare:init-product-grid", {
      detail: {
        compare: compare,
      },
    });
    document.dispatchEvent(event);
  });
};

var setupButtons = function (buttons) {
  buttons.forEach(function (button) {
    var productHandle = button.dataset.productHandle || false;
    if (!productHandle)
      return console.error(
        "[Shopify Compare] Missing `data-product-handle` attribute. Failed to update the compare."
      );
    if (compareContains(productHandle))
      button.classList.add(BUTTON_ACTIVE_CLASS);
  });
};

var initGrid = function () {
  var grid = document.querySelector(selectorsCompare.grid) || false;
  if (grid) setupGrid(grid);
};

var initButtons = function () {
  var buttons = document.querySelectorAll(selectorsCompare.button) || [];
  if (buttons.length) setupButtons(buttons);
  else return;
  var event = new CustomEvent("shopify-compare:init-buttons", {
    detail: {
      compare: getCompare(),
    },
  });
  document.dispatchEvent(event);
};

var getCompare = function () {
  var compare = localStorage.getItem(LOCAL_STORAGE_COMPARE_KEY) || false;
  if (compare) return compare.split(LOCAL_STORAGE_DELIMITER);
  return [];
};

var setCompare = function (array) {
  var compare = array.join(LOCAL_STORAGE_DELIMITER);
  if (array.length) localStorage.setItem(LOCAL_STORAGE_COMPARE_KEY, compare);
  else localStorage.removeItem(LOCAL_STORAGE_COMPARE_KEY);
  return compare;
};

var updateCompare = function (handle) {
  var compare = getCompare();
  var indexInCompare = compare.indexOf(handle);
  if (indexInCompare === -1) compare.push(handle);
  else compare.splice(indexInCompare, 1);
  return setCompare(compare);
};

var compareContains = function (handle) {
  var compare = getCompare();
  return compare.indexOf(handle) !== -1;
};

var resetCompare = function () {
  return setCompare([]);
};

document.addEventListener("click", function (e) {
  if (e.target.classList.contains("button-compare")) {
    let productHandle = e.target.getAttribute("data-product-handle") || false;
    updateCompare(productHandle);
    if (compareContains(productHandle)) {
      e.target.classList.add(BUTTON_ACTIVE_CLASS);
      window.showNotifications(
        window.messNotifications.added_product_to_compare
      );
     
    } else {
      e.target.classList.remove(BUTTON_ACTIVE_CLASS);
      window.showNotifications(
        window.messNotifications.removed_product_from_compare
      );
      

      if (isPageCompare) {
        const cardWrapper = e.target.closest(".tp-prd-item");
        cardWrapper && cardWrapper.remove();
        // Check wishlist remove empty
          let docCardWrapper = document.querySelector(".compare .tp-prd-item");
          if (!docCardWrapper) {
            window.location.reload();
          }
      }
    }
  }
  if (e.target.classList.contains("icon-heart-normal")) {
    const button = e.target.closest(".button-compare");
    let productHandle = button.getAttribute("data-product-handle") || false;
    updateCompare(productHandle);
    if (compareContains(productHandle)) {
      button.classList.add(BUTTON_ACTIVE_CLASS);
    } else {
      button.classList.remove(BUTTON_ACTIVE_CLASS);
      if (isPageCompare) {
        const cardWrapper = e.target.closest(".tp-prd-item");
        cardWrapper && cardWrapper.remove();
      }
    }
  }
});